module.exports = __webpack_public_path__ + "img/cari_ru.e91d41bb.svg";